import store from '../../store/store';
import {isKCPCreditCardAvailable} from '../../selectors/PaymentOptionSelectors/PaymentOptionSelectors';

const koreanCardValidationErrorKey = 'please.use.kcp.for.local.korean.card';

const isKoreanCardWithKCPAvailable = cardNumber => typeof cardNumber === 'string' && cardNumber.charAt(0) === '9' && isKCPCreditCardAvailable(store.getState());

const koreanCardValidation = () => cardNumber => (isKoreanCardWithKCPAvailable(cardNumber)
  ? koreanCardValidationErrorKey
  : undefined);

export default koreanCardValidation;
